import { enumItems } from './enumItems';
import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { ActivityItem } from '../types/entities/ActivityItem';

export const activityItem: SchemaWithClient<ActivityItem> = {
  name: 'Activity Item',
  pluralName: 'Activity Items',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    service_provider: {
      name: 'Provider',
      required: true,
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceProvider),
      switchboard: true,
    },
    price: {
      name: 'Price',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    price_currency: {
      name: 'Price Currency',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    tourist_tax_amount: {
      name: 'Tourist Tax Amount',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    tourist_tax_currency: {
      name: 'Tourist Tax Currency',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    tourist_tax_percentage: {
      name: 'Tourist Tax Percentage',
      fieldRenderer: NumberField,
      fieldType: 'number',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/activity-items'),
};
